/*
 * Aureus – scroll infinito na grelha de produtos (coleções e pesquisa).
 * Melhoria progressiva: a paginação original continua no HTML (SEO / sem JS),
 * apenas fica visualmente escondida quando este script está ativo.
 * Carrega automaticamente até ~48 produtos; depois mostra "Ver mais produtos".
 */
(function () {
  'use strict';
  if (window.__aureusInfiniteScroll) return;
  window.__aureusInfiniteScroll = true;
  if (!('IntersectionObserver' in window) || !('fetch' in window) || !window.DOMParser) return;

  var AUTO_LIMIT = 48;
  var ROOT_MARGIN = '0px 0px 800px 0px';
  var STORE_KEY = 'aureus-infinite-scroll';
  var isEN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var T = isEN
    ? { more: 'Show more products', prev: 'Show previous products', loading: 'Loading products…', error: 'Could not load more products. Try again' }
    : { more: 'Ver mais produtos', prev: 'Ver produtos anteriores', loading: 'A carregar produtos…', error: 'Não foi possível carregar mais produtos. Tentar novamente' };

  var css =
    '.is-infinite .pagination-wrapper{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important;margin:-1px!important;padding:0!important;border:0!important}' +
    '.is-infinite__footer{display:flex;flex-direction:column;align-items:center;gap:1.2rem;margin:3.2rem 0 1rem;min-height:1px}' +
    '.is-infinite__head{display:flex;justify-content:center;margin:0 0 2.4rem}' +
    '.is-infinite__sentinel{display:block!important;width:100%;height:1px}' +
    '.is-infinite__spinner{display:none;width:3.2rem;height:3.2rem;border:.3rem solid rgba(var(--color-foreground),.15);border-top-color:rgba(var(--color-foreground),.75);border-radius:50%;animation:is-infinite-spin .8s linear infinite}' +
    '.is-infinite__footer.is-loading .is-infinite__spinner{display:block}' +
    '.is-infinite__btn[hidden],.is-infinite__head[hidden]{display:none!important}' +
    '@keyframes is-infinite-spin{to{transform:rotate(360deg)}}' +
    '@media (prefers-reduced-motion:reduce){.is-infinite__spinner{animation-duration:2s}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var st = null; // estado da grelha atual
  var gen = 0; // geração: invalida pedidos antigos após filtros/ordenação

  function pageOf(url) {
    var p = parseInt(new URL(url, location.href).searchParams.get('page') || '1', 10);
    return isNaN(p) || p < 1 ? 1 : p;
  }
  function withPage(url, n) {
    var u = new URL(url, location.href);
    if (n > 1) u.searchParams.set('page', String(n));
    else u.searchParams.delete('page');
    return u;
  }
  function listKey(url) {
    var u = new URL(url || location.href, location.href);
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    u.hash = '';
    return u.pathname + u.search;
  }
  function itemKey(li) {
    var a = li.querySelector('a[href]');
    if (!a) return null;
    try { return new URL(a.getAttribute('href'), location.href).pathname; } catch (e) { return null; }
  }
  function findGrid(root) {
    var c = root.getElementById ? root.getElementById('ProductGridContainer') : root.querySelector('#ProductGridContainer');
    c = c || root.querySelector('#ProductGridContainer');
    if (!c) return null;
    var list = c.querySelector('ul.product-grid');
    var pag = c.querySelector('.pagination-wrapper');
    return { container: c, list: list, pag: pag };
  }
  function nextLink(pag) {
    if (!pag) return null;
    // No Dawn/Sense a seta "seguinte" tem a classe pagination__item--prev.
    var a = pag.querySelector('a.pagination__item--prev');
    return a ? a.href : null;
  }
  function totalPages(pag) {
    if (!pag) return 1;
    var max = 1;
    pag.querySelectorAll('.pagination__item').forEach(function (el) {
      var n = parseInt(el.textContent.trim(), 10);
      if (!isNaN(n) && n > max) max = n;
    });
    return max;
  }

  function teardown() {
    if (!st) return;
    gen++;
    if (st.io) st.io.disconnect();
    if (st.ctrl) st.ctrl.abort();
    st = null;
  }

  function init() {
    teardown();
    var g = findGrid(document);
    if (!g || !g.list || !g.pag) return; // uma só página ou sem grelha: nada a fazer
    var next = nextLink(g.pag);
    var current = parseInt(g.pag.getAttribute('data-page') || pageOf(location.href), 10) || 1;
    if (!next && current <= 1) return;

    var sectionHost = g.container.querySelector('[data-id]');
    var myGen = ++gen;
    st = {
      gen: myGen,
      container: g.container,
      list: g.list,
      sectionId: sectionHost ? sectionHost.getAttribute('data-id') : null,
      nextUrl: next,
      firstPage: current,
      lastPage: current,
      pages: totalPages(g.pag),
      loading: false,
      keys: new Set(),
      ctrl: null,
      io: null,
    };
    Array.prototype.forEach.call(g.list.children, function (li) { var k = itemKey(li); if (k) st.keys.add(k); });
    g.container.classList.add('is-infinite');

    // UI: botão "anteriores" (só se entrou numa página > 1), sentinela, spinner e botão "ver mais"
    var head = document.createElement('div');
    head.className = 'is-infinite__head';
    head.hidden = current <= 1;
    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'button button--secondary is-infinite__btn is-infinite__prev';
    prevBtn.textContent = T.prev;
    prevBtn.addEventListener('click', function () { loadPrev(true); });
    head.appendChild(prevBtn);
    g.list.parentNode.insertBefore(head, g.list);

    var foot = document.createElement('div');
    foot.className = 'is-infinite__footer';
    foot.innerHTML =
      '<div class="is-infinite__sentinel" aria-hidden="true"></div>' +
      '<div class="is-infinite__spinner" role="status" aria-label="' + T.loading + '"></div>' +
      '<button type="button" class="button button--secondary is-infinite__btn is-infinite__more" hidden>' + T.more + '</button>';
    g.list.parentNode.insertBefore(foot, g.list.nextSibling);
    st.head = head;
    st.foot = foot;
    st.btn = foot.querySelector('.is-infinite__more');
    st.btn.addEventListener('click', function () { loadNext(true); });
    st.sentinel = foot.querySelector('.is-infinite__sentinel');

    st.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting && autoAllowed()) loadNext(false); });
    }, { rootMargin: ROOT_MARGIN });

    var restored = maybeRestore(myGen);
    if (!restored) arm();
  }

  function autoAllowed() {
    return st && !st.loading && st.nextUrl && st.list.children.length < AUTO_LIMIT;
  }
  function arm() {
    if (!st) return;
    st.foot.classList.remove('is-loading');
    if (!st.nextUrl) { st.btn.hidden = true; st.io.disconnect(); return; }
    if (st.list.children.length < AUTO_LIMIT) {
      st.btn.hidden = true;
      st.io.unobserve(st.sentinel);
      st.io.observe(st.sentinel); // reobservar volta a disparar se ainda estiver visível
    } else {
      st.io.disconnect();
      st.btn.textContent = T.more;
      st.btn.hidden = false;
    }
    st.head.hidden = st.firstPage <= 1;
  }

  function fetchPage(url) {
    var u = new URL(url, location.href);
    if (st.sectionId) u.searchParams.set('section_id', st.sectionId);
    if (st.ctrl) st.ctrl.abort();
    st.ctrl = new AbortController();
    return fetch(u.toString(), { credentials: 'same-origin', signal: st.ctrl.signal })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('ul.product-grid');
        var pag = doc.querySelector('.pagination-wrapper');
        return { items: list ? Array.prototype.slice.call(list.children) : [], next: nextLink(pag) ? new URL(nextLink(pag), location.href).toString() : null };
      });
  }

  function adopt(items) {
    var frag = document.createDocumentFragment();
    var added = 0;
    items.forEach(function (li) {
      var k = itemKey(li);
      if (k && st.keys.has(k)) return; // evita duplicados
      if (k) st.keys.add(k);
      frag.appendChild(document.importNode(li, true));
      added++;
    });
    return { frag: frag, added: added };
  }
  function animate(nodes) {
    if (typeof window.initializeScrollAnimationTrigger !== 'function') return;
    var holder = { getElementsByClassName: function (c) { var out = []; nodes.forEach(function (n) { if (n.classList && n.classList.contains(c)) out.push(n); out.push.apply(out, n.getElementsByClassName(c)); }); return out; } };
    try { window.initializeScrollAnimationTrigger(holder); } catch (e) {}
  }

  function loadNext(manual) {
    if (!st || st.loading || !st.nextUrl) return Promise.resolve();
    var myGen = st.gen;
    var url = st.nextUrl;
    st.loading = true;
    st.btn.hidden = true;
    st.foot.classList.add('is-loading');
    return fetchPage(url).then(function (res) {
      if (!st || st.gen !== myGen) return;
      var r = adopt(res.items);
      var nodes = Array.prototype.slice.call(r.frag.childNodes);
      st.list.appendChild(r.frag);
      animate(nodes);
      st.lastPage = pageOf(url);
      st.nextUrl = res.next;
      st.loading = false;
      try { history.replaceState(history.state, '', withPage(location.href, st.lastPage).toString()); } catch (e) {}
      arm();
    }).catch(function (err) {
      if (!st || st.gen !== myGen || (err && err.name === 'AbortError')) return;
      st.loading = false;
      st.foot.classList.remove('is-loading');
      st.io.disconnect();
      st.btn.textContent = T.error;
      st.btn.hidden = false;
    });
  }

  function loadPrev(keepPosition) {
    if (!st || st.loading || st.firstPage <= 1) return Promise.resolve();
    var myGen = st.gen;
    var p = st.firstPage - 1;
    st.loading = true;
    return fetchPage(withPage(location.href, p).toString()).then(function (res) {
      if (!st || st.gen !== myGen) return;
      var r = adopt(res.items);
      var nodes = Array.prototype.slice.call(r.frag.childNodes);
      var before = document.documentElement.scrollHeight;
      st.list.insertBefore(r.frag, st.list.firstChild);
      if (keepPosition) window.scrollBy(0, document.documentElement.scrollHeight - before);
      animate(nodes);
      st.firstPage = p;
      st.loading = false;
      st.head.hidden = st.firstPage <= 1;
    }).catch(function () { if (st && st.gen === myGen) st.loading = false; });
  }

  // ---- Voltar atrás: repõe as páginas carregadas e a posição ----
  function save() {
    if (!st) return;
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({
        key: listKey(), firstPage: st.firstPage, lastPage: st.lastPage, y: window.scrollY, t: Date.now(),
      }));
    } catch (e) {}
  }
  function maybeRestore(myGen) {
    var rec;
    try { rec = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) { rec = null; }
    if (!rec || rec.key !== listKey() || Date.now() - rec.t > 30 * 60 * 1000) return false;
    if (rec.lastPage !== st.lastPage || rec.firstPage >= st.firstPage) return false;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var target = rec.firstPage;
    var y = rec.y;
    (function step() {
      if (!st || st.gen !== myGen) return;
      if (st.firstPage <= target) { arm(); window.scrollTo(0, y); return; }
      loadPrev(false).then(step);
    })();
    return true;
  }
  window.addEventListener('pagehide', save);
  document.addEventListener('click', function (e) {
    if (st && e.target.closest && e.target.closest('#ProductGridContainer a[href]')) save();
  }, true);
  window.addEventListener('pageshow', function (e) { if (e.persisted && st) arm(); });

  // ---- Filtros/ordenação (facets.js substitui o conteúdo de #ProductGridContainer) ----
  var mo = null;
  var t = null;
  function watch() {
    var c = document.getElementById('ProductGridContainer');
    if (!c || mo) return;
    mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(init, 50); });
    mo.observe(c, { childList: true });
  }

  function start() { init(); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
